import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  Dialog,
  Fade,
  Grid,
  IconButton,
  InputBase,
  Popover,
  Select,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  useMediaQuery,
  CircularProgress,
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import {
  avatar_subtext,
  avatar_text,
  showfont,
  tabs,
  typography_UI,
} from './AppHeader.style';
import { useTheme } from '@emotion/react';
import { ExpandMore, HighlightOff } from '@mui/icons-material';
import MenuItem from '@mui/material/MenuItem';
import Setting_Fill from 'assets/images/Setting_fill.png';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import { styled } from '@mui/material/styles';
import { notificationcontext } from './AppHeader';
import moment from 'moment';
import {
  GET_PROPERTY_ADDRESS,
  APP_SCALE,
  DESKTOP_BREAKPOINT,
} from 'constant/app.config';
import { getApiCall } from 'api/apiService';
import Loading from 'assets/images/loading.png';
import dayjs from 'dayjs';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import Swal from 'sweetalert2';
import {
  markMoxoAllAsRead,
  markMoxoAsRead,
  updateMoxoNotificationAction,
} from 'api/rcpapiService';

const BellIcon = () => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0391 0.667969H9.96181C6.31191 0.667969 2.96538 3.31625 2.64071 6.82234C2.61906 7.07315 2.6043 7.32945 2.59477 7.60554L2.58143 8.25102L2.57879 8.82975L2.59509 8.76378C2.44446 9.49827 2.09731 10.1796 1.58954 10.7362L1.51677 10.8299C1.082 11.4903 0.832189 12.2548 0.793521 13.0442L0.792605 13.3023C0.770409 14.3405 1.12618 15.3679 1.79547 16.1838C2.7031 17.1421 3.878 17.7138 5.139 17.8351C8.36412 18.1853 11.6271 18.1853 14.8612 17.8342C16.1136 17.7189 17.292 17.1456 18.1616 16.2227C18.8182 15.4372 19.1765 14.4945 19.2072 13.5185L19.2083 13.0816C19.1724 12.2575 18.921 11.4923 18.481 10.8347L18.4141 10.7489L18.2509 10.5569C17.884 10.0987 17.6161 9.57083 17.4637 9.00626L17.4154 8.80355L17.4054 8.59096C17.4024 8.49534 17.4009 8.38932 17.4005 8.25689L17.4003 7.5277C17.3978 7.24876 17.3895 7.05041 17.3703 6.82711C17.0345 3.31439 13.687 0.667969 10.0391 0.667969ZM9.96181 2.1796H10.0391C12.9614 2.1796 15.6272 4.28712 15.8833 6.96567C15.8984 7.14152 15.9052 7.30928 15.9072 7.55851L15.9101 8.53853C15.9134 8.69527 15.9195 8.82561 15.93 8.97227L15.944 9.07266L16.0143 9.37143C16.2226 10.1618 16.5967 10.8991 17.1117 11.5347L17.2611 11.7099L17.2446 11.6824C17.5302 12.1093 17.693 12.6047 17.7157 13.1156L17.715 13.2927C17.7322 14.0034 17.4966 14.6788 17.0507 15.2135C16.4615 15.8368 15.6193 16.2466 14.7139 16.33C11.5737 16.6708 8.41752 16.6708 5.28928 16.3312C4.37402 16.2431 3.53118 15.833 2.90812 15.1771C2.50423 14.6816 2.27112 14.0084 2.28575 13.3185L2.28592 13.0816L2.30485 12.8752C2.35043 12.5299 2.46579 12.18 2.64461 11.8578L2.73529 11.7077C3.40007 10.96 3.85629 10.0509 4.05723 9.07103L4.07282 8.9174L4.07989 7.92152L4.09728 7.41627C4.10517 7.25688 4.11527 7.10544 4.12794 6.95864C4.37533 4.28724 7.03868 2.1796 9.96181 2.1796ZM2.73529 11.7077C2.71922 11.7258 2.70302 11.7438 2.68669 11.7617L2.74007 11.6998L2.73529 11.7077ZM12.8252 19.8328C12.5039 19.5711 12.0339 19.6227 11.7755 19.9479C11.6634 20.0889 11.5337 20.2153 11.3894 20.3242C10.8999 20.7081 10.2891 20.8791 9.68189 20.8067C9.07554 20.7345 8.52437 20.4259 8.15039 19.9507C7.89343 19.6243 7.42367 19.5704 7.10115 19.8306C6.77863 20.0907 6.72547 20.5662 6.98243 20.8927C7.60255 21.6806 8.51122 22.1894 9.50737 22.308C10.5026 22.4266 11.5048 22.1461 12.2931 21.5276C12.5271 21.3512 12.7479 21.1359 12.939 20.8955C13.1975 20.5702 13.1465 20.0945 12.8252 19.8328Z"
        fill="#666666"
      />
    </svg>
  );
};

export const Cancelicon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.41421"
        y1="1"
        x2="15"
        y2="14.5858"
        stroke="#AEAAB5"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="1"
        y1="14.5858"
        x2="14.5858"
        y2="1"
        stroke="#AEAAB5"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

function Notificationpopups() {
  const {
    openBellicon,
    setOpenBellicon,
    openBelliconpops,
    setOpenBelliconpops,
    showpopup,
    Openmessage,
    actionitem_datas,
    showicon,
    impdata,
    setShowpopup,
    setShowid,
    setBinderid,
    setShowicon,
    showid,
    binderid,
    usermail,
    Notify,
    isfetching,
    trashdata,
    dataType,
    taskdata,
    responseCount,
  } = useContext(notificationcontext);

  const theme = useTheme();
  const isDesktop = useMediaQuery(`(min-width:${DESKTOP_BREAKPOINT}px)`);
  const capitalize = (text) => text?.charAt(0).toUpperCase() + text?.slice(1);
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches1300 = useMediaQuery(theme.breakpoints.down(1300));
  const matches365 = useMediaQuery(theme.breakpoints.down(365));
  const matches79 = useMediaQuery(theme.breakpoints.between(700, 900));

  const mi_avatar = {
    bgcolor: '#6C2AD2',
    color: 'white',
    fontSize: matchessm ? '10px' : '16px',
    fontFamily: 'Poppins',
    width: matchessm ? '25px' : '39px',
    height: matchessm ? '25px' : '40px',
    Padding: '5px, 8px, 5px, 8px',
    borderRadius: '5px',
  };

  const [value, setValue] = React.useState(0);
  const [showvalue, setShowvalue] = useState('All');
  const [showmarkallread, setShowmarkallread] = useState(false);
  const [hasValidNotifications, setHasValidNotifications] = useState(false);
  const [confirmationPopup, setConfirmationPopup] = useState({
    visible: false,
    address: '',
    propertyId: '',
    notificationId: '',
    status: '', // "subscribe" or "unsubscribe"
    loading: false,
    binderId: '',
    title: '',
  });

  useEffect(() => {
    setHasValidNotifications(false); // Reset state before rechecking
  }, [showvalue, value]);

  useEffect(() => {
    setShowmarkallread(false);
  }, [responseCount, actionitem_datas]);

  const handleChange = (event, newValue) => {
    Notify({
      fetchFilters: true,
      showLoader: false,
    });
    setValue(newValue);
  };
  const handleshowvalChange = (e) => {
    setValue(0);
    setShowvalue(e.target.value);
  };

  const Forward = (props) => {
    let { matchessm } = props;
    return (
      <svg
        width={matchessm ? '20' : '30'}
        height={matchessm ? '20' : '30'}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 23.75L8.79603 15.046L17.5 6.34207"
          stroke="#9D9C9E"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const CustomBackdrop = styled(Backdrop, {
    name: 'MuiModal', // This ensures proper styling inheritance and overrides
    slot: 'Backdrop',
    overridesResolver: (props, styles) => {
      return styles.backdrop;
    },
  })({
    zIndex: 0, // Custom styles for the Backdrop
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // You can customize this as needed
  });

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const Unsubsicon = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.9636 0.263601C17.3151 -0.0878669 17.885 -0.0878669 18.2364 0.263601C18.5879 0.615078 18.5879 1.18492 18.2364 1.5364L14.5335 5.23931C14.7704 5.84709 14.9005 6.50836 14.9005 7.2V8.55V10.4396L16.3562 12.4413C16.7544 12.9888 16.8117 13.7135 16.5044 14.3168C16.1973 14.9201 15.5775 15.3 14.9005 15.3H12.2005C12.2005 16.7912 10.9917 18 9.50046 18C8.00934 18 6.80048 16.7912 6.80048 15.3H4.47279L2.0364 17.7364C1.68492 18.0878 1.11508 18.0878 0.763601 17.7364C0.412133 17.3849 0.412133 16.8151 0.763601 16.4636L16.9636 0.263601ZM6.2728 13.5H6.32617H8.60046H10.4005H10.4015H12.6748H14.9005L13.5914 11.7L13.4447 11.4984C13.221 11.1907 13.1005 10.8201 13.1005 10.4396V8.55V7.2C13.1005 7.03239 13.089 6.86746 13.0669 6.70594L6.2728 13.5ZM9.50046 0C8.50641 0 7.70046 0.805887 7.70046 1.8V2.10727C5.60312 2.84857 4.10047 4.8488 4.10047 7.2V8.55V10.4396L5.90047 8.8065V8.55V7.2C5.90047 5.21177 7.51225 3.6 9.50046 3.6C9.97647 3.6 10.4309 3.69238 10.8468 3.86019L12.1904 2.5166C11.9088 2.3545 11.6111 2.21708 11.3005 2.10727V1.8C11.3005 0.805887 10.4946 0 9.50046 0ZM9.50046 16.2C9.00339 16.2 8.60046 15.7971 8.60046 15.3H10.4005C10.4005 15.7971 9.99753 16.2 9.50046 16.2Z"
          fill="#666666"
        />
      </svg>
    );
  };
  const Subsicon = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.0057 19.8318H1.99161C1.59079 19.8318 1.20013 19.7056 0.874977 19.4713C0.549825 19.2369 0.306669 18.9061 0.179959 18.5258C0.0532488 18.1456 0.0494094 17.7351 0.168985 17.3525C0.28856 16.9699 0.525486 16.6347 0.846198 16.3943L1.70401 15.7509C2.02684 15.5096 2.24343 15.1525 2.30818 14.7547L3.38443 8.2214C3.6472 6.52259 4.5092 4.97388 5.81455 3.85537C7.11989 2.73685 8.78241 2.12237 10.5014 2.12305C12.2204 2.12373 13.8825 2.73952 15.1869 3.85907C16.4914 4.97862 17.3522 6.528 17.6136 8.22702L18.6891 14.7547C18.7539 15.1525 18.9705 15.5096 19.2933 15.7509L20.1514 16.3943C20.4721 16.6347 20.7091 16.97 20.8287 17.3526C20.9483 17.7352 20.9444 18.1458 20.8176 18.5261C20.6909 18.9064 20.4476 19.2371 20.1224 19.4715C19.7971 19.7058 19.4064 19.8319 19.0055 19.8318H19.0057ZM10.4994 3.1651C9.02681 3.15795 7.60093 3.68173 6.48312 4.64046C5.36531 5.59918 4.63044 6.92863 4.41318 8.38515L3.33615 14.924C3.22809 15.5868 2.86708 16.1819 2.32911 16.584L1.47104 17.2276C1.32524 17.3369 1.21752 17.4893 1.16317 17.6632C1.10881 17.8371 1.11057 18.0237 1.16819 18.1966C1.22581 18.3695 1.33637 18.5198 1.48421 18.6263C1.63205 18.7329 1.80966 18.7902 1.99187 18.7901H19.0059C19.1881 18.7901 19.3657 18.7328 19.5134 18.6263C19.6612 18.5198 19.7718 18.3695 19.8294 18.1967C19.887 18.0239 19.8888 17.8373 19.8345 17.6634C19.7801 17.4895 19.6725 17.3372 19.5268 17.2279L18.6684 16.584C18.1305 16.1819 17.7695 15.5868 17.6614 14.924L16.5848 8.39072C16.3687 6.9334 15.6344 5.60285 14.5167 4.64304C13.3989 3.68324 11.9727 3.15852 10.4994 3.1651Z"
          fill="#666666"
          stroke="#666666"
          strokeWidth="0.9"
        />
        <path
          d="M12.0599 3.35352C11.9218 3.35352 11.7893 3.29864 11.6916 3.20097C11.5939 3.10329 11.5391 2.97082 11.5391 2.83268V2.12435C11.5391 1.84808 11.4293 1.58313 11.234 1.38778C11.0386 1.19243 10.7737 1.08268 10.4974 1.08268C10.2211 1.08268 9.95618 1.19243 9.76083 1.38778C9.56548 1.58313 9.45573 1.84808 9.45573 2.12435V2.83268C9.45573 2.97082 9.40086 3.10329 9.30318 3.20097C9.20551 3.29864 9.07303 3.35352 8.9349 3.35352C8.79676 3.35352 8.66429 3.29864 8.56661 3.20097C8.46894 3.10329 8.41406 2.97082 8.41406 2.83268V2.12435C8.41406 1.57181 8.63356 1.04191 9.02426 0.65121C9.41496 0.260509 9.94486 0.0410156 10.4974 0.0410156C11.0499 0.0410156 11.5798 0.260509 11.9705 0.65121C12.3612 1.04191 12.5807 1.57181 12.5807 2.12435V2.83268C12.5807 2.97082 12.5259 3.10329 12.4282 3.20097C12.3305 3.29864 12.198 3.35352 12.0599 3.35352Z"
          fill="#666666"
          stroke="#666666"
          strokeWidth="0.9"
        />
        <path
          d="M10.4974 22.9577C9.53079 22.9566 8.60408 22.5721 7.92059 21.8887C7.2371 21.2052 6.85264 20.2785 6.85156 19.3118C6.85156 19.1737 6.90644 19.0412 7.00411 18.9436C7.10179 18.8459 7.23426 18.791 7.3724 18.791C7.51053 18.791 7.64301 18.8459 7.74068 18.9436C7.83836 19.0412 7.89323 19.1737 7.89323 19.3118C7.89323 20.0025 8.1676 20.6649 8.65597 21.1533C9.14435 21.6416 9.80673 21.916 10.4974 21.916C11.1881 21.916 11.8504 21.6416 12.3388 21.1533C12.8272 20.6649 13.1016 20.0025 13.1016 19.3118C13.1016 19.1737 13.1564 19.0412 13.2541 18.9436C13.3518 18.8459 13.4843 18.791 13.6224 18.791C13.7605 18.791 13.893 18.8459 13.9907 18.9436C14.0884 19.0412 14.1432 19.1737 14.1432 19.3118C14.1422 20.2785 13.7577 21.2052 13.0742 21.8887C12.3907 22.5721 11.464 22.9566 10.4974 22.9577Z"
          fill="#666666"
          stroke="#666666"
          strokeWidth="0.9"
        />
      </svg>
    );
  };
  const Star = ({ color, stroke }) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99937 14.7918L4.85604 17.496L5.83854 11.7685L1.67188 7.71262L7.42187 6.87929L9.99354 1.66846L12.5652 6.87929L18.3152 7.71262L14.1485 11.7685L15.131 17.496L9.99937 14.7918Z"
          stroke={stroke}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill={color}
        />
      </svg>
    );
  };
  const Deleteicon = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 4.75H16.25L15.8125 13.4997C15.6795 16.1607 13.4831 18.25 10.8188 18.25H8.18125C5.51688 18.25 3.32054 16.1607 3.18748 13.4997L2.75 4.75Z"
          stroke="#666666"
          stroke-width="2"
        />
        <path
          d="M5.75 4.75V4.75C5.75 3.09315 7.09315 1.75 8.75 1.75H10.25C11.9069 1.75 13.25 3.09315 13.25 4.75V4.75"
          stroke="#666666"
          stroke-width="2"
        />
        <path
          d="M1.25 4.75H17.75"
          stroke="#666666"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M11.75 9.25V13"
          stroke="#666666"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M7.25 9.25V13"
          stroke="#666666"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  const openConfirmationPopup = async (
    propertyId,
    notificationId,
    binderId,
    title,
    action
  ) => {
    try {
      const res = await getApiCall(`${GET_PROPERTY_ADDRESS}/${propertyId}`);
      const address = res?.data?.propertyAddress?.streetName || '';
      if (address) {
        setConfirmationPopup({
          visible: true,
          address: address,
          propertyId: propertyId,
          notificationId: notificationId,
          status: action,
          binderId: binderId,
          loading: false,
          title: title,
        });
      }
    } catch (err) {
      console.error('Error loading confirmation popup data:', err);
    }
  };

  const handleSubscriptionChange = async () => {
    setConfirmationPopup((prev) => ({
      ...prev,
      loading: true,
      visible: false,
    }));

    try {
      const { notificationId, binderId, status } = confirmationPopup;

      // status === 'subscribe' → subscribe (true)
      // otherwise → unsubscribe (false)
      const value = status === 'subscribe';

      const success = await updateActionItems(
        notificationId,
        'subscribe',
        value,
        binderId
      );

      if (success?.data?.code == 'YRY_OK') {
        setConfirmationPopup((prev) => ({
          ...prev,
          loading: false,
          visible: false,
        }));
        Notify({
          fetchFilters: true,
          showLoader: false,
        });
        Swal.fire({
          title: success?.data?.heading || 'Success',
          text: success?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          setConfirmationPopup((prev) => ({ ...prev, visible: false }));
        });
      } else {
        setConfirmationPopup((prev) => ({
          ...prev,
          loading: false,
          visible: false,
        }));
      }
    } catch (error) {
      console.error(error);

      setConfirmationPopup((prev) => ({
        ...prev,
        loading: false,
        visible: false,
      }));
    }
  };

  const closeConfirmationPopup = () => {
    setConfirmationPopup({
      visible: false,
      address: '',
      propertyId: '',
      notificationId: '',
      status: '',
      loading: false,
      binderId: '',
    });
  };

  const updateActionItems = async (id, action, value, binder_id) => {
    try {
      const resp = await updateMoxoNotificationAction(id, action, value);

      // optional: check response code
      if (resp?.code === 'YRY_OK') {
        Notify({
          fetchFilters: true,
          showLoader: false,
        });
        // optional: refresh actions list or binder details
        // await getMoxoActionsByFilter('subscribe');
        // await getMoxoBinderdetails(binder_id);
      }
    } catch (error) {
      console.error('Failed to update action item:', error);
    }
  };

  // Mark notification as read when user clicks on it, if it's not already read
  const handleMarkAsRead = async (id, readstatus) => {
    if (readstatus) return;

    try {
      await markMoxoAsRead(id);
      Notify({
        fetchFilters: true,
        showLoader: false,
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Mark all notification as read when user clicks on it, if some notifications are not read
  const handleMarkAllAsRead = async () => {
    try {
      await markMoxoAllAsRead();
      Notify({
        fetchFilters: true,
        showLoader: false,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const timeAgo = (params) => {
    if (params?.transobject?.status == 'completed') {
      const now = new Date();
      const previousTime = new Date(params.transobject?.expiration_date);

      const timeDifference = now - previousTime;
      const minutes = Math.floor(timeDifference / (1000 * 60));
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const weeks = Math.floor(days / 7);
      const months = Math.floor(days / 30);
      if (months > 0) {
        return `${weeks} month${weeks > 1 ? 's' : ''} ago`;
      } else if (weeks > 0) {
        return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
      } else if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''} ago`;
      } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ago`;
      } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
      }
    } else {
      const now = new Date();
      const previousTime = moment(
        new Date(params.transobject?.expiration_date)
      ).format('DD MMMM YYYY');
      return previousTime;
    }
  };

  const Statuslabel = (params, onlystatus) => {
    const now = new Date();
    const timestamp = new Date(params.transobject?.expiration_date);
    let label;
    if (params?.transobject?.status == 'completed') {
      label = 'Completed';
    } else if (timestamp > now) {
      label = 'Due';
    } else if (timestamp < now) {
      label = 'Overdue';
    } else {
    }

    return onlystatus ? (
      label
    ) : (
      <Typography
        sx={{
          fontSize: matchessm ? '12px' : '16px',
          fontFamily: 'poppins',
          fontWeight: '600',
          color: label == 'Overdue' ? '#CB5B66' : '#666666',
        }}
        whiteSpace={'nowrap'}
      >
        {label}: &nbsp;
        <Typography sx={[typography_UI, { fontSize: matchessm ? '12px' : '' }]}>
          {timeAgo(params)}
        </Typography>
      </Typography>
    );
  };

  const Notificationcontent = ({ category, actionItem }) => {
    let creator = '';
    let creator_initials = '';
    let creator_mail = '';
    let title = '';
    let subtitle = '';
    let binder_id = actionItem?.binder_id;
    let id = '';
    let impstatus = false;
    let unsubsstatus = false;
    let readstatus = false;
    creator = actionItem?.transobject?.sender_name;
    creator_initials = actionItem?.transobject?.initials;
    creator_mail = actionItem?.transobject?.sender_email;
    title = actionItem?.transobject?.title;
    subtitle = actionItem?.transobject?.sub_title;
    id = actionItem?.transobject?.id;
    if (creator_mail !== usermail) {
      impstatus = actionItem?.transobject?.isImportant == 1 ? true : false;
      unsubsstatus = actionItem?.transobject?.isSubscribe == 1 ? true : false;
      readstatus = actionItem?.transobject?.isRead == 1 ? true : false;

      if (
        (showvalue.includes('Read') && readstatus == true) ||
        (showvalue.includes('Unread') && readstatus == false) ||
        showvalue.includes('All') ||
        (actionItem.transobject?.expiration_date &&
          ((showvalue.includes('Planned') &&
            Statuslabel(actionItem, 'onlystatus') == 'Due') ||
            (showvalue.includes('OverDue') &&
              Statuslabel(actionItem, 'onlystatus') == 'Overdue'))) ||
        (showvalue.includes('Completed') &&
          actionItem.transobject?.status == 'completed') ||
        value == 1 || // for important tab
        value == 2 || // for tasks tab
        value == 3
      ) {
        // for trash tab
        setHasValidNotifications(true); // Set flag when valid notification is found

        return (
          <Box
            style={{ padding: '15px 15px 15px 15px' }}
            onMouseEnter={() => {
              setShowicon(true);
              setShowid(id);
              setBinderid(binder_id);
            }}
            onMouseLeave={() => {
              setShowicon(false);
              setShowid(id);
              setBinderid(binder_id);
            }}
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              handleMarkAsRead(id, readstatus);
              Openmessage(
                actionItem?.transobject?.propertyId,
                actionItem?.binder_id,
                actionItem?.object_type == 'signature'
                  ? actionItem?.signature?.file_name
                  : `${title}`,
                subtitle,
                creator_mail
              );
            }}
          >
            <Box
              style={{
                padding: '15px',
                border: '1px solid ',
                borderColor: readstatus ? '#C4C4C4' : 'grey',
                backgroundColor: readstatus ? 'transparent' : '#6C2AD21A',
                borderRadius: '5px',
              }}
            >
              <Grid container>
                <Grid item container>
                  <Grid
                    container
                    item
                    xs={12}
                    display={'flex'}
                    flexDirection={'row'}
                    spacing={1}
                    alignItems={'center'}
                  >
                    <Grid item xs={1} height={matchessm ? '100%' : null}>
                      <Tooltip
                        title={
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '14px',
                            }}
                          >
                            {creator}
                          </Typography>
                        }
                        arrow
                        placement="top"
                        PopperProps={{
                          sx: { zIndex: 2000001 },
                        }}
                      >
                        <Avatar sx={mi_avatar} variant="rounded">
                          {creator_initials}
                        </Avatar>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      xs={11}
                      display={showicon && 'flex'}
                      justifyContent={showicon && 'space-between'}
                    >
                      <Typography
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          paddingLeft: '5px',
                          width: '100%',
                        }}
                      >
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Typography
                            sx={[
                              avatar_text,
                              { fontSize: matchessm ? '12px' : '16px' },
                            ]}
                          >
                            {actionItem?.object_type == 'signature'
                              ? actionItem?.signature?.file_name
                              : `${title}`}
                          </Typography>
                          {(matchesmd ||
                            (showid == id &&
                              showicon &&
                              binderid == binder_id)) &&
                            (category == 'trash' ? (
                              <Typography
                                style={{
                                  fontFamily: 'Poppins',
                                  fontSize: '12px',
                                  fontWeight: '400',
                                  color: 'blue',
                                  display: 'flex',
                                  gap: '15px',
                                  cursor: 'pointer',
                                }}
                              >
                                <Typography
                                  sx={{ fontFamily: 'poppins' }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    updateActionItems(
                                      id,
                                      'trash',
                                      false,
                                      binder_id
                                    );
                                  }}
                                >
                                  Restore
                                </Typography>
                              </Typography>
                            ) : (
                              <Typography
                                style={{
                                  fontFamily: 'Poppins',
                                  fontSize: '15px',
                                  fontWeight: '400',
                                  color: 'rgba(102, 102, 102, 1)',
                                  display: 'flex',
                                  gap: matches700 ? '10px' : '15px',
                                  alignItems: 'start',
                                }}
                              >
                                <Tooltip
                                  title={
                                    <Typography
                                      sx={{
                                        fontFamily: 'poppins',
                                        fontSize: '14px',
                                      }}
                                    >
                                      Important
                                    </Typography>
                                  }
                                  arrow
                                  placement="top"
                                  PopperProps={{
                                    sx: { zIndex: 2000001 },
                                  }}
                                >
                                  <Typography
                                    sx={{ cursor: 'pointer' }}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      updateActionItems(
                                        id,
                                        'important',
                                        !impstatus,
                                        binder_id
                                      );
                                    }}
                                  >
                                    <Star
                                      color={impstatus ? '#F1CB1E' : '#ffff'}
                                      stroke={impstatus ? '#F1CB1E' : '#666666'}
                                    />
                                  </Typography>
                                </Tooltip>
                                {actionItem?.transobject?.propertyId != 0 && (
                                  <Tooltip
                                    title={
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          fontSize: '14px',
                                        }}
                                      >
                                        {!unsubsstatus
                                          ? 'Subscribe'
                                          : 'Unsubscribe'}
                                      </Typography>
                                    }
                                    arrow
                                    placement="top"
                                    PopperProps={{
                                      sx: { zIndex: 2000001 },
                                    }}
                                  >
                                    <Typography
                                      sx={{ cursor: 'pointer' }}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        openConfirmationPopup(
                                          actionItem?.transobject?.propertyId,
                                          id,
                                          binder_id,
                                          actionItem?.object_type == 'signature'
                                            ? actionItem?.signature?.file_name
                                            : `${title}`,
                                          !unsubsstatus
                                            ? 'subscribe'
                                            : 'unsubscribe'
                                        );
                                      }}
                                    >
                                      {unsubsstatus ? (
                                        <Subsicon />
                                      ) : (
                                        <Unsubsicon />
                                      )}
                                    </Typography>
                                  </Tooltip>
                                )}
                                <Tooltip
                                  title={
                                    <Typography
                                      sx={{
                                        fontFamily: 'poppins',
                                        fontSize: '14px',
                                      }}
                                    >
                                      Remove
                                    </Typography>
                                  }
                                  arrow
                                  placement="top"
                                  PopperProps={{
                                    sx: { zIndex: 2000001 },
                                  }}
                                >
                                  <Typography
                                    sx={{ cursor: 'pointer' }}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      updateActionItems(
                                        id,
                                        'trash',
                                        true,
                                        binder_id
                                      );
                                    }}
                                  >
                                    <Deleteicon />
                                  </Typography>
                                </Tooltip>
                                {!readstatus && (
                                  <Tooltip
                                    title={
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          fontSize: '14px',
                                        }}
                                      >
                                        Mark as read
                                      </Typography>
                                    }
                                    arrow
                                    placement="top"
                                    PopperProps={{
                                      sx: { zIndex: 2000001 },
                                    }}
                                  >
                                    <Checkbox
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleMarkAsRead(id, readstatus);
                                      }}
                                      sx={{
                                        height: '15px',
                                        width: '15px',
                                        marginTop: '2px',
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </Typography>
                            ))}
                        </Grid>

                        <Typography
                          sx={[
                            avatar_subtext,
                            { fontSize: matchessm ? '11px' : '' },
                          ]}
                        >
                          {actionItem?.object_type == 'signature'
                            ? actionItem?.signature?.flow
                              ? actionItem?.signature?.flow?.description
                              : 'E-Sign assigned to you'
                            : subtitle
                            ? `${subtitle}`
                            : ''}
                        </Typography>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  container
                  style={{
                    paddingTop: '10px',
                    paddingLeft: !matchessm && '5%',
                  }}
                >
                  <Grid container sx={{ wordWrap: 'break-word' }}>
                    <Typography
                      sx={[
                        typography_UI,
                        {
                          fontSize: matchessm ? '12px' : '',
                          flex: 1,
                          flexWrap: 'wrap',
                        },
                      ]}
                    >
                      {' '}
                      {actionItem?.binder_name}
                    </Typography>
                  </Grid>

                  {actionItem?.transobject?.created_time && (
                    <Typography
                      sx={[
                        typography_UI,
                        {
                          fontSize: matchessm ? '12px' : '',
                          flex: 1,
                          flexWrap: 'wrap',
                        },
                      ]}
                    >
                      {' '}
                      Received:{' '}
                      {actionItem?.transobject?.created_time
                        ? dayjs(actionItem?.transobject?.created_time).format(
                            'HH:mm:ss DD-MM-YY'
                          )
                        : null}
                    </Typography>
                  )}

                  {actionItem.transobject?.expiration_date &&
                  actionItem.transobject?.expiration_date != 0 ? (
                    <Grid
                      item
                      xl={5}
                      lg={5}
                      md={6}
                      sm={12}
                      xs={12}
                      display={'flex'}
                      justifyContent={'right'}
                    >
                      {Statuslabel(actionItem)}
                    </Grid>
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        );
      }
    }
  };

  const Nodata_text = ({ show_text }) => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography
          sx={[
            typography_UI,
            {
              textAlign: 'center',
              width: '100%',
              marginTop: '50px',
            },
          ]}
        >
          {show_text}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Dialog
        open={openBelliconpops}
        TransitionComponent={Fade}
        hideBackdrop={true}
        fullScreen={!isDesktop ? true : false}
        disableScrollLock={true}
        disableRestoreFocus={true}
        disableEnforceFocus={true}
        disableAutoFocus={true}
        slots={{
          backdrop: CustomBackdrop, // Use the custom-styled Backdrop
        }}
        TransitionProps={{
          timeout: 1000,
          onExited: () => setOpenBelliconpops(false),
        }}
        sx={{
          zIndex: '1000000 !important',
          '& .MuiDialog-paper': isDesktop && {
            transform: `scale(${APP_SCALE})`,
            transformOrigin: 'top right',
          },
          maxHeight: '270px',
          maxWidth: '700px',
          position: 'absolute',
          right: '0px !important',
          left: 'unset',
          display: 'flex',
          alignItems: 'start',
          zIndex: '1000000 !important',
        }}
        PaperProps={{
          sx: {
            position: 'fixed',
            top: isDesktop && '52px',
            right: '0px',
            margin: '0px',
            borderRadius: '5px',
            maxHeight: '270px',
            minHeight: 'fit-content',
            backgroundColor: 'transparent',
            width: matches400 ? '100%' : '85%',
            zIndex: '1000000 !important',
            boxShadow: 'none',
            '-webkit-scrollbar': {
              display: 'none',
            },
            '-ms-overflow-style': 'none' /* IE and Edge */,
            'scrollbar-width': 'none',
          },
        }}
      >
        {showpopup.slice(0, 1)?.map((actionItem) => {
          let creator = {};
          let creator_initials = '';
          let creator_mail = '';
          let title = {};
          let subtitle = {};
          let binder_id = actionItem?.binder_id;
          let id = {};
          let impstatus = false;
          let unsubsstatus = false;
          let readstatus = false;
          creator = actionItem?.transobject?.sender_name;
          creator_initials = actionItem?.transobject?.initials;
          creator_mail = actionItem?.transobject?.sender_email;
          title = actionItem?.transobject?.title;
          subtitle = actionItem?.transobject?.sub_title;
          id = actionItem?.transobject?.id;
          if (creator_mail !== usermail) {
            impstatus =
              actionItem?.transobject?.isImportant == 1 ? true : false;
            unsubsstatus =
              actionItem?.transobject?.isSubscribe == 1 ? true : false;
            readstatus = actionItem?.transobject?.isRead == 1 ? true : false;
            if (
              (showvalue.includes('Read') && readstatus == true) ||
              (showvalue.includes('Unread') && readstatus == false) ||
              showvalue.includes('All') ||
              showvalue.includes('Overdue')
            ) {
              return (
                <Box
                  onClick={() => {
                    handleMarkAsRead(id, readstatus);

                    Openmessage(
                      actionItem?.transobject?.propertyId,
                      actionItem?.binder_id,
                      actionItem?.object_type == 'signature'
                        ? actionItem?.signature?.file_name
                        : `${title}`,
                      subtitle,
                      creator_mail
                    );
                  }}
                  conatiner
                  sx={{
                    padding: '10px',
                    backgroundColor: 'transparent !important',
                    cursor: 'pointer',
                  }}
                >
                  <Box sx={{ backgroundColor: '#ffff', borderRadius: '5px' }}>
                    <Box
                      style={{
                        position: 'relative',
                        padding: '15px',
                        border: '1px solid ',
                        borderColor: readstatus ? '#C4C4C4' : 'grey',
                        backgroundColor: readstatus
                          ? 'transparent'
                          : '#6C2AD21A',
                        borderRadius: '5px',
                      }}
                    >
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: '-12px',
                          right: '-12px',
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          setShowpopup([]);
                          setOpenBelliconpops(false);
                        }}
                      >
                        <HighlightOff
                          sx={{ backgroundColor: 'white', borderRadius: '50%' }}
                        />
                      </IconButton>
                      {showpopup?.length > 1 && (
                        <Badge
                          badgeContent={showpopup?.length.toString()} // You can change this depending on what you want to show
                          color="error" // This sets the badge color to red
                          overlap="circular"
                          sx={{
                            '& .MuiBadge-dot': {
                              backgroundColor: '#f44336',
                            },

                            '& .MuiBadge-badge': {
                              position: 'absolute',
                              right: '-15px !important',
                              fontFamily: 'poppins',
                            },
                            width: 'fit-content !important',
                            height: '100% !important',
                          }}
                        >
                          <Typography
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              fontFamily: 'poppins',
                              fontWeight: 500,
                              fontSize: matchessm ? '14px' : '18px',
                              paddingBottom: '10px',
                            }}
                          >
                            <BellIcon /> Unread Notifications
                          </Typography>
                        </Badge>
                      )}
                      <Grid conatiner>
                        <Grid item container>
                          <Grid
                            container
                            item
                            xs={12}
                            display={'flex'}
                            flexDirection={'row'}
                            spacing={1}
                            alignItems={'center'}
                          >
                            {matchessm ? (
                              <Grid
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'top',
                                  width: '100%',
                                }}
                              >
                                <Grid
                                  item
                                  xs={1}
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    handleMarkAsRead(id, readstatus);

                                    Openmessage(
                                      actionItem?.transobject?.propertyId,
                                      actionItem?.binder_id,
                                      actionItem?.object_type == 'signature'
                                        ? actionItem?.signature?.file_name
                                        : `${title}`,
                                      subtitle,
                                      creator_mail
                                    );
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          fontSize: '14px',
                                        }}
                                      >
                                        {creator}
                                      </Typography>
                                    }
                                    arrow
                                    placement="top"
                                    PopperProps={{
                                      sx: { zIndex: 2000001 },
                                    }}
                                  >
                                    <Avatar
                                      sx={[
                                        mi_avatar,
                                        {
                                          fontSize: matchessm ? '12px' : '16px',
                                          width: matchessm ? '29px' : '39px',
                                          height: matchessm ? '29px' : '40px',
                                        },
                                      ]}
                                      variant="rounded"
                                    >
                                      {creator_initials}
                                    </Avatar>
                                  </Tooltip>
                                </Grid>
                              </Grid>
                            ) : (
                              <Grid
                                item
                                xs={1}
                                sx={{ cursor: 'pointer' }}
                                onClick={() => {
                                  handleMarkAsRead(id, readstatus);

                                  Openmessage(
                                    actionItem?.transobject?.propertyId,
                                    actionItem?.binder_id,
                                    actionItem?.object_type == 'signature'
                                      ? actionItem?.signature?.file_name
                                      : `${title}`,
                                    subtitle,
                                    creator_mail
                                  );
                                }}
                              >
                                <Tooltip
                                  title={
                                    <Typography
                                      sx={{
                                        fontFamily: 'poppins',
                                        fontSize: '14px',
                                      }}
                                    >
                                      {creator}
                                    </Typography>
                                  }
                                  arrow
                                  placement="top"
                                  PopperProps={{
                                    sx: { zIndex: 2000001 },
                                  }}
                                >
                                  <Avatar sx={mi_avatar} variant="rounded">
                                    {creator_initials}
                                  </Avatar>
                                </Tooltip>
                              </Grid>
                            )}
                            <Grid
                              item
                              xs={11}
                              display={showicon && 'flex'}
                              justifyContent={showicon && 'space-between'}
                            >
                              <Typography
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                                onClick={() => {
                                  handleMarkAsRead(id, readstatus);

                                  Openmessage(
                                    actionItem?.transobject?.propertyId,
                                    actionItem?.binder_id,
                                    actionItem?.object_type == 'signature'
                                      ? actionItem?.signature?.file_name
                                      : `${title}`,
                                    subtitle,
                                    creator_mail
                                  );
                                }}
                              >
                                <Typography
                                  sx={[
                                    avatar_text,
                                    { fontSize: matchessm ? '12px' : '16px' },
                                  ]}
                                >
                                  {actionItem?.object_type == 'signature'
                                    ? actionItem?.signature?.file_name
                                    : `${title}`}
                                </Typography>
                                <Typography
                                  sx={[
                                    avatar_subtext,
                                    { fontSize: matchessm ? '11px' : '' },
                                  ]}
                                >
                                  {actionItem?.object_type == 'signature'
                                    ? actionItem?.signature?.flow
                                      ? actionItem?.signature?.flow?.description
                                      : 'E-Sign assigned to you'
                                    : subtitle
                                    ? `${subtitle}`
                                    : ''}
                                </Typography>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          container
                          style={{
                            paddingTop: '15px',
                            marginTop: matchessm ? '-20px' : '',
                            paddingLeft: !matchessm && '5%',
                          }}
                        >
                          <Grid container item>
                            <Grid
                              item
                              xl={7}
                              lg={7}
                              md={6}
                              sm={12}
                              xs={12}
                              sx={{ wordWrap: 'break-word' }}
                            >
                              <Typography
                                sx={[
                                  typography_UI,
                                  {
                                    fontSize: matchessm ? '12px' : '',
                                    flex: 1,
                                    flexWrap: 'wrap',
                                  },
                                ]}
                              >
                                {' '}
                                {actionItem?.binder_name}
                              </Typography>
                            </Grid>
                            {actionItem.transobject?.expiration_date &&
                            actionItem.transobject?.expiration_date != 0 ? (
                              <Grid
                                item
                                xl={5}
                                lg={5}
                                md={6}
                                sm={12}
                                xs={12}
                                display={'flex'}
                                justifyContent={'right'}
                              >
                                {Statuslabel(actionItem)}
                              </Grid>
                            ) : (
                              ''
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      {showpopup?.length > 1 && (
                        <Grid
                          onClick={(event) => {
                            event.stopPropagation();
                            setShowpopup([]);
                            setOpenBelliconpops(false);
                            setOpenBellicon(true);
                          }}
                          width={'100%'}
                          sx={{
                            ...poppins300,
                            fontSize: matchessm ? '14px' : '18px',
                            textAlign: 'end',
                            color: 'blue',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          Show All
                        </Grid>
                      )}
                    </Box>
                  </Box>
                </Box>
              );
            }
          }
        })}
      </Dialog>

      <Dialog
        open={openBellicon}
        onClose={() => setOpenBellicon(!openBellicon)}
        fullScreen={!isDesktop ? true : false}
        sx={{
          zIndex: '1000000 !important',
          '& .MuiDialog-paper': isDesktop && {
            transform: `scale(${APP_SCALE})`,
            transformOrigin: 'top right',
          },
        }}
        PaperProps={{
          sx: {
            position: 'absolute',
            right: 0,
            top: isDesktop && '52px',
            bottom: isDesktop && '63px',
            borderRadius: '5px',
            paddingBottom: matchessm && '140px',
            height: isDesktop && `calc(90vh / ${APP_SCALE})`,
            maxHeight: isDesktop && `calc(90vh / ${APP_SCALE})`,
            minHeight: !isDesktop && '100%',
            width: matches700 ? '100%' : '85%',
            margin: '0px',
            zIndex: '1000000 !important',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            '-webkit-scrollbar': {
              display: 'none',
            },
            '-ms-overflow-style': 'none' /* IE and Edge */,
            'scrollbar-width': 'none',
          },
        }}
        BackdropProps={{ invisible: true }}
      >
        <Grid container width={'100%'}>
          <Grid
            item
            container
            width={'100%'}
            style={{
              padding: '20px 15px 20px 15px',
              display: 'flex',
              flexDirection: 'row',
              borderBottom: '1px solid #C4C4C4',
            }}
          >
            <Grid
              container
              item
              xs={12}
              display={'flex'}
              flexDirection={'row'}
              width={'100%'}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Grid item xs={4}>
                <Stack
                  direction={'row'}
                  spacing={'3px'}
                  justifyContent="flex-start"
                  onClick={() => {
                    setOpenBellicon(!openBellicon);
                  }}
                >
                  <Typography sx={{ cursor: 'pointer' }}>
                    <Forward matchessm={matchessm} />
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: matchessm ? '15px' : '24px',
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                    }}
                  >
                    Notification
                  </Typography>
                </Stack>
              </Grid>

              <Grid
                item
                xs={8}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'right'}
              >
                <Stack direction={'row'} spacing={1}>
                  <Typography
                    sx={{
                      fontSize: matchessm ? '12px' : '16px',
                      fontFamily: 'Poppins',
                      fontWeight: '400',
                      alignItems: 'center',
                      color:
                        !showmarkallread && responseCount?.full_unread_count > 0
                          ? '#666666'
                          : '#999999',
                      lineHeight: '2',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {matchessm
                      ? 'Mark all as read'
                      : 'Mark all notifications as read'}
                  </Typography>
                  <Typography
                    sx={{
                      lineHeight: '1.5',
                      flexdirection: 'row',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <Checkbox
                      checked={showmarkallread}
                      disabled={
                        !showmarkallread && responseCount?.full_unread_count > 0
                          ? false
                          : true
                      }
                      onClick={(event) => {
                        event.stopPropagation();
                        handleMarkAllAsRead();
                        setShowmarkallread(true);
                      }}
                      sx={{
                        height: '15px',
                        width: '15px',
                        color:
                          !showmarkallread &&
                          responseCount?.full_unread_count > 0
                            ? '#666666'
                            : '#999999',
                      }}
                    />
                    <img alt="Setting_Fill" src={Setting_Fill} />
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Box sx={{ width: '100%' }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="visible arrows tabs example"
              scrollButtons={matchessm ? 'auto' : 'off'}
              variant="scrollable"
              allowScrollButtonsMobile
            >
              <Tab
                label={showvalue}
                {...a11yProps(0)}
                sx={[
                  tabs,
                  {
                    fontSize: matchessm ? '11px' : '14px',
                    '&.MuiTab-root': {
                      minWidth: matchesmd ? 'fit-content' : null,
                    },
                  },
                ]}
              />

              <Tab
                label={
                  <Badge
                    badgeContent={responseCount?.important?.toString() || 0} // You can change this depending on what you want to show
                    color="#6C2AD221" // This sets the badge color to red
                    overlap="circular"
                    invisible={responseCount?.important == 0 ? true : false}
                    sx={{
                      '& .MuiBadge-dot': {
                        backgroundColor: '#6C2AD221',
                      },

                      '& .MuiBadge-badge': {
                        position: 'absolute',
                        right: '-10px !important',
                        top: '0px !important',
                        fontFamily: 'poppins',
                        fontSize: '8px',
                        width: '15px !important',
                        height: '18px !important',
                        backgroundColor: '#6C2AD221',
                        color: '#6C2AD2',
                      },
                    }}
                  >
                    Important
                  </Badge>
                }
                {...a11yProps(1)}
                sx={[
                  tabs,
                  {
                    fontSize: matchessm ? '11px' : '14px',
                    '&.MuiTab-root': {
                      minWidth: matchesmd ? 'fit-content' : null,
                    },
                  },
                ]}
              />
              <Tab
                label={
                  <Badge
                    badgeContent={responseCount?.task?.toString() || 0} // You can change this depending on what you want to show
                    color="#6C2AD221" // This sets the badge color to red
                    overlap="circular"
                    invisible={responseCount?.task == 0 ? true : false}
                    sx={{
                      '& .MuiBadge-dot': {
                        backgroundColor: '#6C2AD221',
                      },

                      '& .MuiBadge-badge': {
                        position: 'absolute',
                        right: '-10px !important',
                        top: '0px !important',
                        fontFamily: 'poppins',
                        fontSize: '8px',
                        width: '15px !important',
                        height: '18px !important',
                        backgroundColor: '#6C2AD221',
                        color: '#6C2AD2',
                      },
                    }}
                  >
                    Tasks
                  </Badge>
                }
                {...a11yProps(2)}
                sx={[
                  tabs,
                  {
                    fontSize: matchessm ? '11px' : '14px',
                    '&.MuiTab-root': {
                      minWidth: matchesmd ? 'fit-content' : null,
                    },
                  },
                ]}
              />

              <Tab
                label={
                  <Badge
                    badgeContent={responseCount?.trash?.toString() || 0} // You can change this depending on what you want to show
                    color="#6C2AD221" // This sets the badge color to red
                    overlap="circular"
                    invisible={responseCount?.trash == 0 ? true : false}
                    sx={{
                      '& .MuiBadge-dot': {
                        backgroundColor: '#6C2AD221',
                      },

                      '& .MuiBadge-badge': {
                        position: 'absolute',
                        right: '-10px !important',
                        top: '0px !important',
                        fontFamily: 'poppins',
                        fontSize: '8px',
                        width: '15px !important',
                        height: '18px !important',
                        backgroundColor: '#6C2AD221',
                        color: '#6C2AD2',
                      },
                    }}
                  >
                    Trash
                  </Badge>
                }
                {...a11yProps(3)}
                sx={[
                  tabs,
                  {
                    fontSize: matchessm ? '11px' : '14px',
                    '&.MuiTab-root': {
                      minWidth: matchesmd ? 'fit-content' : null,
                    },
                  },
                ]}
              />
            </Tabs>
            <Select
              disableUnderline
              required
              IconComponent={ExpandMore}
              onChange={handleshowvalChange}
              sx={{
                fontFamily: 'Poppins',
                fontStyle: 'normal !important',
                fontWeight: '300 !important',
                fontSize: matches400 ? '12px' : '14px',
                height: '38px',
                alignItems: 'center',
                borderRadius: '20px',
                backgroundColor: '#F8F8F8',
                padding: '0px',
                marginRight: '5px',
              }}
              value={showvalue}
              displayEmpty
              MenuProps={{
                sx: {
                  zIndex: '2000000 !important',
                },
              }}
            >
              <MenuItem
                value="All"
                sx={[
                  showfont,
                  {
                    fontSize: matchessm ? '12px' : '',
                    minHeight: matchessm ? '0px' : '',
                  },
                ]}
                selected
              >
                Show All
              </MenuItem>
              <MenuItem
                value="Read"
                sx={[
                  showfont,
                  {
                    fontSize: matchessm ? '12px' : '',
                    minHeight: matchessm ? '0px' : '',
                  },
                ]}
                selected
              >
                Show read
              </MenuItem>
              <MenuItem
                value="Unread"
                sx={[
                  showfont,
                  {
                    fontSize: matchessm ? '12px' : '',
                    minHeight: matchessm ? '0px' : '',
                  },
                ]}
                selected
              >
                Show Unread
              </MenuItem>
              <MenuItem
                value="OverDue"
                sx={[
                  showfont,
                  {
                    fontSize: matchessm ? '12px' : '',
                    minHeight: matchessm ? '0px' : '',
                  },
                ]}
                selected
              >
                Show OverDue
              </MenuItem>
              <MenuItem
                value="Planned"
                sx={[
                  showfont,
                  {
                    fontSize: matchessm ? '12px' : '',
                    minHeight: matchessm ? '0px' : '',
                  },
                ]}
              >
                Show Planned
              </MenuItem>
              <MenuItem
                value="Completed"
                sx={[
                  showfont,
                  {
                    fontSize: matchessm ? '12px' : '',
                    minHeight: matchessm ? '0px' : '',
                  },
                ]}
                selected
              >
                Show Completed
              </MenuItem>
            </Select>
          </Box>
          <CustomTabPanel value={value} index={0}>
            {isfetching ? (
              <Grid
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  margin: '120px 0',
                }}
              >
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '100px', width: '100px' }}
                />
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 600,
                  }}
                >
                  Loading...
                </Typography>
              </Grid>
            ) : (
              <>
                {actionitem_datas && actionitem_datas.length > 0 ? (
                  <>
                    {actionitem_datas.map((actionItem) => {
                      return (
                        <Notificationcontent
                          key={actionItem.transobject.id}
                          category={'Overdue'}
                          actionItem={actionItem}
                          setHasValidNotifications={setHasValidNotifications}
                        />
                      );
                    })}

                    {!hasValidNotifications && (
                      <Nodata_text show_text="No notification available" />
                    )}
                  </>
                ) : (
                  <Nodata_text show_text="No notification available" />
                )}
              </>
            )}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Box container></Box>
            {impdata && impdata?.length > 0 ? (
              impdata.map((actionItem) => (
                <Notificationcontent
                  category={'important'}
                  actionItem={actionItem}
                />
              ))
            ) : (
              <Nodata_text show_text="No important notification available" />
            )}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            {taskdata.length > 0 ? (
              taskdata.map((actionItem) => (
                <Notificationcontent
                  category={'task'}
                  actionItem={actionItem}
                />
              ))
            ) : (
              <Nodata_text show_text="No task available" />
            )}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            {trashdata.length > 0 ? (
              trashdata?.map((actionItem) => (
                <Notificationcontent
                  category={'trash'}
                  actionItem={actionItem}
                />
              ))
            ) : (
              <Nodata_text show_text="Trash empty" />
            )}
          </CustomTabPanel>
        </Box>
      </Dialog>

      <Dialog
        open={confirmationPopup.visible}
        sx={{ zIndex: '1000000 !important' }}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '550px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
            zIndex: '1000000 !important',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
              }}
            >
              {confirmationPopup.address}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            {' '}
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '18px' : '24px',
                paddingLeft: '12px',
                width: '85%',
              }}
            >
              {capitalize(confirmationPopup.status)} from "
              {confirmationPopup.title}" Notifications
            </Typography>
          </Grid>
          <Grid item textAlign={'left'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '14px' : '16px',
                color: '#666666',
              }}
            >
              Are you sure you want to {confirmationPopup.status} from "
              {confirmationPopup.title}" notifications for{' '}
              <b>"{confirmationPopup.address}"</b>? <br />
              {confirmationPopup.status != 'subscribe' && (
                <>
                  You’ll still receive other updates related to this property.
                </>
              )}
            </Typography>
          </Grid>

          <Grid item textAlign={'left'} marginTop={3}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesmd ? '12px' : '16px',
                color: '#666666',
              }}
            ></Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? 2 : 4}
          >
            <Grid item>
              <Button
                disabled={confirmationPopup.loading}
                variant="outlined"
                onClick={closeConfirmationPopup}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                disabled={confirmationPopup.loading}
                variant="outlined"
                onClick={handleSubscriptionChange}
                sx={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: 400,
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                  '&:hover': {
                    background: '#4CA4D6',
                    boxShadow: 'none', // if you want to prevent elevation/shadow change
                  },
                }}
              >
                {capitalize(confirmationPopup.status)}
              </Button>

              {confirmationPopup.loading && (
                <CircularProgress
                  size={matchessm ? 25 : 32}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#4CA4D6',
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}

export default Notificationpopups;
